import React, { useEffect, useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// import Share from "yet-another-react-lightbox/plugins/share";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useGalleryImageContext } from "../../context/GalleryImageContext";
import { formatDateDetails } from "../../exports/functions";
import { useLoader } from "../../context/LoaderContext";
import { Fade } from "react-awesome-reveal";
import { useEventContext } from "../../context/EventContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const GalleryImage = () => {
  const { loading } = useLoader();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { index } = useParams<{ index: string }>();
  const [searchParams] = useSearchParams();
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const galleryGridRef = useRef<HTMLDivElement>(null);
  const { galleryImageData } = useGalleryImageContext();
  const { eventData } = useEventContext();
  const [currentIndex, setCurrentIndex] = useState<number>();

  useEffect(() => {
    setCurrentIndex(parseInt(index ?? "0", 10));
  }, [index]);

  const images =
    searchParams.get("category") === "gallery"
      ? (galleryImageData?.map((data) => ({
          id: data?.id,
          title: data?.title,
          Date: data?.date,
          image:
            data?.images?.map((img) => img?.media?.url).filter(Boolean) ?? [],
        })) ?? [])
      : (eventData?.map((data) => ({
          id: data?.id,
          title: data?.event_name,
          Date: data?.from_date,
          image:
            data?.images?.map((img) => img?.media?.url).filter(Boolean) ?? [],
        })) ?? []);
  const filteredGallery = images.find((img) => img.id === currentIndex);
  const formatedDate = formatDateDetails(filteredGallery?.Date || "");

  useEffect(() => {
    if (
      (galleryImageData?.length > 0 || eventData?.length > 0) &&
      filteredGallery &&
      galleryGridRef.current
    ) {
      const timeout = setTimeout(() => {
        galleryGridRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [galleryImageData, eventData, filteredGallery, currentIndex]);

  if (!filteredGallery) {
    return <p>No gallery found for this ID.</p>;
  }

  const lightboxSlides = (filteredGallery.image ?? []).map((src) => ({
    src: `${process.env.REACT_APP_cmsUrl}${src}`,
  }));
  const handleSlideClick = (index: number) => {
    setLightboxIndex(index);
    setOpen(true);
  };
  return (
    <>
      <div ref={galleryGridRef}></div>
      <section className="events-page custom-padding">
        <div className="container">
          <div className="section-title custom-text-center">
            <span className="custom-fontweight">{formatedDate?.Full_Date}</span>
            <h2 className="section-title__title">{filteredGallery?.title}</h2>
          </div>
          <h6 className="back-to-album-h3">
            <div className="back-to-album" onClick={() => navigate("/gallery")}>
              <i className="icon-arrow-left2 custom-arrow-left"></i>
              &nbsp; Back to Album
            </div>
          </h6>
          <div className="row" style={{ justifyContent: "center" }}>
            {!loading &&
              ((filteredGallery?.image ?? []).length > 0 ? (
                filteredGallery.image.map((image, index) => (
                  <div className="col-5th custom-margin-bottom" key={index}>
                    <Fade
                      cascade
                      damping={0.2}
                      triggerOnce={true}
                      delay={index * 200}
                    >
                      <div className="events__single">
                        <div
                          className="events__img custom-events_img"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() => handleSlideClick(index)}
                        >
                          <img
                            src={`${process.env.REACT_APP_cmsUrl}${image}`}
                            alt="gallery-image"
                            className="row-image"
                            style={{
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                    </Fade>
                  </div>
                ))
              ) : (
                <div className="text-center custom-fontweight">
                  <p>No Images</p>
                </div>
              ))}
          </div>
        </div>
      </section>
      <Lightbox
        open={open}
        plugins={[
          Counter,
          Fullscreen,
          //   Share,
          Slideshow,
          Video,
          Zoom,
          Thumbnails,
        ]}
        close={() => setOpen(false)}
        slides={lightboxSlides}
        index={lightboxIndex}
      />
    </>
  );
};

export default GalleryImage;
